import { createStore } from "redux";
import { applyMiddleware } from "redux";
import addToCartReducer from "./addToCart/addToCartReducer";
import logger from "redux-logger";
import myLogger from "../middlewares/myLogger";
import stockChecker from "../middlewares/stockChecker";



const store = createStore(addToCartReducer, applyMiddleware(stockChecker,myLogger,logger));

export default store;